function createResizer(gantt, grid) {
  return {
    init: function init() {},
    doOnRender: function doOnRender() {}
  };
}

module.exports = createResizer;